exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loader[data-v-6428c8d2]{\n  height: 100px;\n  width: 100%;\n  text-align: center;\n  padding: 1em;\n  margin: 0 auto 1em;\n  display: inline-block;\n  vertical-align: top;\n}\nsvg path[data-v-6428c8d2] {\n  fill: #ffa035;\n}\n", ""]);

// exports
